module.exports = __webpack_public_path__ + "img/1273620817.853dc9ba.jpg";